<template>
  <section>
    <div class="box">
      <div class="box-title">
        <h3>Active Campaign</h3>
      </div>
      <div class="box-content">
        <p>
          Para começar a útilizar precisamos que você informe o urlapi, apikey da sua conta do active campaign.
        </p>
        <p class="margin-top-s">
          Acesse: <a href="https://help.activecampaign.com/hc/pt-br/articles/207317590-Primeiros-passos-com-a-API" target="_blank">https://help.activecampaign.com/hc/pt-br/articles/207317590-Primeiros-passos-com-a-API</a>
        </p>
        <form>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>Url:</label>
              <input class="input" type="text" v-model="urlapi" />
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>Chave da Api:</label>
              <input class="input" type="text" v-model="apikey" />
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class="">
              <div class="button primary" @click="saveActiveCampaign()">
                Salvar
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

import {
  saveIntegration,
  getIntegrations,
  deleteIntegration,
} from "@/services/integration";


export default {
  name: "active-campaign",
  components: {},
  data() {
    return {
      urlapi: "",
      apikey: "",
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  mounted() {
    this.getIntegrations();
  },
  methods: {
    saveActiveCampaign() {
      let data = {
        urlapi: this.urlapi,
        apikey: this.apikey,
      };

      if (!data.apikey || !data.urlapi) {
        this.$toast.error({
          title: "Erro",
          message: "Você precisa preencher os campos para salvar a integração!",
        });
      }

      let params = {
        activecampaign: {
          urlapi: this.urlapi,
          apikey: this.apikey,
        },
      };

      saveIntegration(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Integração salva com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao tentar salvar integração",
          });
        });
    },
    getIntegrations() {
      getIntegrations()
        .then((result) => {
          this.urlapi = result.activecampaign.urlapi;
          this.apikey = result.activecampaign.apikey;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar integrações",
          });
        });
    },
    deleteIntegration() {
      deleteIntegration()
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>
